/* =========================================================================
   Brain2Canvas — Referenzen-Übersicht: Filter-Choreografie
   Kein GSAP, kein Lenis, keine Icon-Library. Alles nativ.

   Die Wand steht bereits statisch im HTML (build.mjs). Dieses Skript
   HYDRIERT sie nur:
     · es merkt sich jede Karte als DOM-Knoten in einem Pool
     · beim Filtern werden dieselben Knoten umgehängt, nicht neu gebaut
       → die Karten, die bleiben, WANDERN wirklich (FLIP), statt neu
         gerendert zu werden. Das war der Grund für den harten Sprung.
     · abgehende Karten kippen weg, neue klappen aus der Wand auf
   Denkregel aus gsap-plugins/Flip: erst messen, dann DOM ändern,
   dann invertieren, dann abspielen — hier nativ per Web Animations API.
   ========================================================================= */
(function () {
  'use strict';

  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var filtersEl = document.getElementById('filters');
  var wallEl = document.getElementById('wall');
  var statusEl = document.getElementById('wall-status');
  if (!wallEl || !filtersEl) return;

  /* --- Pool: alle Karten, in Ausgangsreihenfolge, als echte Knoten --- */
  var pool = [].slice.call(wallEl.querySelectorAll('.card[data-key]'));
  var cta = wallEl.querySelector('.ctatile');
  if (!pool.length) return;

  var active = 'Alle';
  var emptyEl = null;

  function matches(el, cat) {
    return cat === 'Alle' || el.getAttribute('data-cat') === cat;
  }

  /* ------------------------------------------------------ FLIP-Umbau ---- */
  function apply(cat) {
    var keep = pool.filter(function (el) { return matches(el, cat); });
    var drop = pool.filter(function (el) { return !matches(el, cat); });

    // FIRST: Position aller aktuell hängenden Karten merken
    var before = new Map();
    pool.forEach(function (el) {
      if (el.parentNode === wallEl) before.set(el, el.getBoundingClientRect());
    });

    // DOM umhängen: erst abgehende raus, dann Zielreihenfolge herstellen
    drop.forEach(function (el) {
      if (el.parentNode === wallEl) {
        if (reduce || !el.animate) { wallEl.removeChild(el); return; }
        var tilt = el.style.getPropertyValue('--tilt') || '0deg';
        var a = el.animate(
          [{ transform: 'rotate(' + tilt + ')', opacity: 1 },
           { transform: 'translateY(10px) scale(.9) rotate(calc(' + tilt + ' - 4deg))', opacity: 0 }],
          { duration: 260, easing: 'cubic-bezier(.4,0,.9,.3)', fill: 'forwards' }
        );
        el._out = a;                       // merken, um sie beim Wiederkommen
        el.style.pointerEvents = 'none';   // zu verwerfen (fill:forwards!)
        a.finished.then(function () {
          if (el.parentNode === wallEl) wallEl.removeChild(el);
          el.style.pointerEvents = '';
        }).catch(function () { /* abgebrochen: die Karte kommt zurück */ });
      }
    });

    var fresh = [];
    keep.forEach(function (el, i) {
      // Eine noch laufende oder mit fill:forwards liegengebliebene
      // Abgangs-Animation würde die zurückkehrende Karte unsichtbar halten.
      if (el._out) { el._out.cancel(); el._out = null; el.style.pointerEvents = ''; }
      var isNew = el.parentNode !== wallEl;
      if (isNew) fresh.push(el);
      el.classList.toggle('card--feature', i === 0);
      wallEl.insertBefore(el, cta);
    });

    if (emptyEl) { emptyEl.remove(); emptyEl = null; }
    if (!keep.length) {
      emptyEl = document.createElement('p');
      emptyEl.className = 'empty';
      emptyEl.textContent = 'In dieser Kategorie hängt noch nichts an der Wand';
      wallEl.insertBefore(emptyEl, cta);
    }

    if (statusEl) {
      statusEl.textContent = keep.length
        ? keep.length + ' Projekte in der Kategorie ' + cat
        : 'Keine Projekte in der Kategorie ' + cat;
    }

    if (reduce || !wallEl.animate) return;

    // LAST + INVERT + PLAY
    var i = 0;
    keep.forEach(function (el) {
      el.classList.add('in');
      var tilt = el.style.getPropertyValue('--tilt') || '0deg';
      var now = el.getBoundingClientRect();
      var was = before.get(el);
      var delay = Math.min(i, 9) * 26;
      i++;

      if (was) {
        var dx = was.left - now.left;
        var dy = was.top - now.top;
        var dsx = was.width / (now.width || 1);
        if (Math.abs(dx) < 1 && Math.abs(dy) < 1 && Math.abs(dsx - 1) < 0.01) return;
        el.animate(
          [{ transform: 'translate(' + dx + 'px,' + dy + 'px) rotate(' + tilt + ')' },
           { transform: 'rotate(' + tilt + ')' }],
          { duration: 620, easing: 'cubic-bezier(.16,1,.3,1)', delay: delay, composite: 'replace' }
        );
      } else {
        el.animate(
          [{ transform: 'translateY(18px) scale(.94) rotate(calc(' + tilt + ' + 2deg))', opacity: 0 },
           { transform: 'rotate(' + tilt + ')', opacity: 1 }],
          { duration: 520, easing: 'cubic-bezier(.16,1,.3,1)', delay: 160 + delay, fill: 'backwards' }
        );
      }
    });
    void fresh;
  }

  /* --------------------------------------------------------- Bedienung -- */
  filtersEl.addEventListener('click', function (ev) {
    var btn = ev.target.closest('.chip');
    if (!btn) return;
    var next = btn.getAttribute('data-cat');
    if (next === active) return;
    active = next;
    filtersEl.querySelectorAll('.chip').forEach(function (c) {
      c.setAttribute('aria-pressed', String(c === btn));
    });
    // die gehobene Hover-Lage der geklickten Pille nicht einfrieren
    btn.blur();
    apply(active);
    if (window.B2C && window.B2C.track) {
      window.B2C.track({
        event: 'ref_filter_click',
        ref_filter: active,
        ref_result_count: pool.filter(function (el) { return matches(el, active); }).length
      });
    }
  });

  /* Erste Karte trägt die Feature-Rolle bereits aus dem Build. */
})();
